module.exports = __webpack_public_path__ + "media/images/icons/location-icon-3f9fb08f9e7da9af3133c99da80676b1.svg";